import styles from "./ReviewSlider.module.css";
import { useEffect, useState } from "react";

const reviews = [
  {
    author: "Jennifer W.",
    quote: "Such a relaxing and peaceful place for a perfect vacation.",
  },
  {
    author: "Leslie W.",
    quote:
      "My favorite beach vacation by far. The host was in great communication throughout our stay.",
  },
  {
    author: "Pat S.",
    quote: "Oh. My. Word... Big Blue was all we hoped for. Highly recommend!",
  },
  {
    author: "Angela M.",
    quote:
      "The place couldn’t have been any better. I would definitely stay there again!",
  },
  {
    author: "Maggie B.",
    quote: "You won’t find a better view at the beach!",
  },
];

const ReviewSlider = () => {
  const [index, setIndex] = useState(0);
  const [fadeKey, setFadeKey] = useState(0); // to re-trigger animation

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => {
        const next = (prev + 1) % reviews.length;
        setFadeKey(next); // update to trigger re-animation
        return next;
      });
    }, 6000);
    return () => clearInterval(interval);
  }, []);

  const { author, quote } = reviews[index];

  return (
    <div className={`${styles["slider-wrapper"]} md:h-[150px] h-[200px]`}>
      <div
        key={fadeKey}
        className={`${styles["review-item"]}  ${styles["fade-in"]}`}
      >
        <p className={`text-center md:text-4xl text-2xl`}>{quote}</p>
        <p className="text-center md:text-2xl text-xl mt-2">- {author}</p>
      </div>
    </div>
  );
};

export default ReviewSlider;
